import { Component } from '@angular/core';

@Component({
    selector: 'app-sidebar-skeleton-loader',
    template: `
    <div style="
        padding: 56px 26px 16px 26px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow-y: auto;
    ">
        <span>
            <div 
                class="skeleton-loader" 
                style="
                    width: 100%;
                    height: 33px;
                    margin: 36px auto;
                "
            ></div>
            <div 
                class="skeleton-loader" 
                style="
                    width: 100%;
                    height: 24px;
                    margin-bottom: 8px;
                "
            ></div>
            <div 
                *ngFor="let item of [].constructor(4); let row1Index = index" 
                class="skeleton-loader" 
                style="
                    width: 100%;
                    height: 15px;
                    margin-bottom: 26px;
                "
            ></div>
            <div 
                class="skeleton-loader" 
                style="
                    width: 100%;
                    max-width: 64px; 
                    height: 15px;
                    margin-top: 32px;
                    margin-bottom: 26px;
                "
            ></div>
            <div 
                *ngFor="let item of [].constructor(4); let row1Index = index" 
                class="skeleton-loader" 
                style="
                    width: 100%;
                    height: 15px;
                    margin-bottom: 26px;
                "
            ></div>
        </span>
        <span>
            <div 
                class="skeleton-loader" 
                style="
                    width: 100%;
                    height: 15px;
                    margin-bottom: 12px;
                "
            ></div>
            <div class="d-flex flex-row" style="margin-bottom: 12px;">
                <div 
                    class="skeleton-loader" 
                    style="
                        width: 100%;
                        height: 15px;
                    "
                ></div>
                <div 
                    style="
                        width: 15px;
                        height: 15px;
                    "
                ></div>
                <div 
                    class="skeleton-loader" 
                    style="
                        width: 100%;
                        height: 15px;
                    "
                ></div>
            </div>
        </span>
    </div>`,
    standalone: false
})
export class SidebarSkeletonComponent {}